import React, { useState, useEffect } from "react";
import Gallery from "react-grid-gallery";
import LabelItem from "./subComponents/LabelItem/LabelItem";
import MainTitleItem from "./subComponents/MainTitleItem/MainTitleItem";
import SubtitleItem from "./subComponents/SubtitleItem/SubtitleItem";
import ColumnsItem from "./subComponents/ColumnsItem/ColumnsItem";
import UserItem from "./subComponents/UserItem/UserItem";
import CalendarItem from "./subComponents/CalendarItem/CalendarItem";
import SubKeyInfoItem from "./subComponents/SubKeyInfoItem/SubKeyInfoItem";
import KeyInfoItem from "./subComponents/KeyInfoItem/KeyInfoItem";

import "./advertisementItem.less";
import FormComplete from "../FormsV2/FormComplete";
import { Modal } from "../BP2Components";
import { fixedHTML } from "./utils";

const AdvertisementItem = ({
   grid,
   rows,
   columns,
   isPhotoVisible,
   showDisplayOptions,
   showAlignGridContentCenter,
   showMainTitleLabel,
   showSubtitleLabel,
   showLabelLabel,
   showKeyInfoLabel,
   showSubKeyInfoLabel,
   showUserLabel,
   showCalendarLabel,
   showRestOfColumnsLabel,
   buttons,
   mainTitle,
   subtitle,
   photoColumn = "Zdjęcie",
   label,
   keyInfo,
   subKeyInfo,
   user,
   calendar,
   restOfColumns,
   calendarFormat,
   compactImageSize,
   previewOnClick,
   displayFormChildId,
}) => {
   const [image, setImage] = useState("");
   const [isPreviewOpen, setIsPreviewOpen] = useState(false);
   const isSelectedColValid = (elem) => {
      if (columns.find((col) => col.title === elem) || elem === "-") return elem;
      else return "-";
   };
   const getTitleFromTechName = (techName) => {
      return columns.find((column) => column.techName === techName)?.title;
   };

   const handleModalOpen = () => previewOnClick && !!displayFormChildId && setIsPreviewOpen(true);

   useEffect(() => {
      const wanted = new Set([photoColumn]);
      const col =
         columns?.find((column) => wanted.has(column.techName)) ??
         columns?.find((column) => wanted.has(column.dataIndex));

      const key = col?.dataIndex;
      const cell = key ? rows?.[key] : undefined;

      const pickUrl = (file) =>
         file?.altUrl ?? file?.altUrl1 ?? file?.fileUrl ?? file?.rawUrl ?? null;

      let url = null;
      if (Array.isArray(cell) && cell[0]) {
         const file = cell[0];
         url = pickUrl(file);
         if (url && file?.type === "GDrive") {
            url = url.replace("/file/d/", "/uc?export=view&id=").replace("/view?usp=drivesdk", "");
         }
      } else if (cell) {
         url = pickUrl(cell);
      }

      setImage(url || undefined);
   }, [rows, columns, photoColumn]);

   mainTitle = isSelectedColValid(getTitleFromTechName(mainTitle));
   subtitle = isSelectedColValid(getTitleFromTechName(subtitle));
   label = isSelectedColValid(getTitleFromTechName(label));
   keyInfo = isSelectedColValid(getTitleFromTechName(keyInfo));
   subKeyInfo = isSelectedColValid(getTitleFromTechName(subKeyInfo));
   user = isSelectedColValid(getTitleFromTechName(user));
   calendar = isSelectedColValid(getTitleFromTechName(calendar));
   restOfColumns = restOfColumns
      ? restOfColumns.map((elem) => isSelectedColValid(getTitleFromTechName(elem)))
      : [];

   return (
      <div
         className={`gx-product-item ${
            showDisplayOptions === "displayNormal"
               ? "avdertisement-item"
               : showDisplayOptions === "displayGrid"
                 ? showAlignGridContentCenter === false
                    ? "avdertisement-grid-item-center"
                    : showAlignGridContentCenter === undefined
                      ? "avdertisement-grid-item-center"
                      : "avdertisement-grid-item"
                 : showDisplayOptions === "displaySmall"
                   ? "avdertisement-small-item"
                   : null
         } ${grid ? "gx-product-vertical" : "gx-product-horizontal"}`}
      >
         {isPhotoVisible === true ? (
            <div
               className="gx-product-image avdertisement-item-image"
               style={{ width: !!compactImageSize ? `${compactImageSize}px` : "100px" }}
            >
               <div className="gx-grid-thumb-equal">
                  <span className="gx-link gx-grid-thumb-cover">
                     {image ? (
                        <Gallery
                           images={[
                              {
                                 src: image,
                                 thumbnail: image,
                                 thumbnailHeight: 150,
                              },
                           ]}
                           backdropClosesModal={true}
                           enableImageSelection={false}
                        />
                     ) : null}
                  </span>
               </div>
            </div>
         ) : (
            ""
         )}
         <div
            style={{
               width:
                  isPhotoVisible && showDisplayOptions === "displaySmall"
                     ? `calc(100% - 10px - ${!!compactImageSize ? compactImageSize : 100}px)`
                     : "",
            }}
            className={
               "avdertisement-item-body-and-buttons-container" +
               (isPhotoVisible !== true
                  ? " avdertisement-item-body-and-buttons-container-without-image"
                  : "")
            }
         >
            {showDisplayOptions === "displaySmall" ? (
               <div
                  className="columns-container"
                  onClick={handleModalOpen}
                  style={{ cursor: previewOnClick && !!displayFormChildId && "pointer" }}
               >
                  <div className="columns1">
                     <span>
                        <LabelItem
                           showTitle={showLabelLabel}
                           value={(label !== "-" || label === null) && fixedHTML(rows[label])}
                           title={label}
                        />
                     </span>
                     <span>
                        <MainTitleItem
                           showTitle={showMainTitleLabel}
                           value={
                              (mainTitle !== "-" || mainTitle === null) &&
                              fixedHTML(rows[mainTitle])
                           }
                           title={mainTitle}
                        />
                     </span>
                     <span>
                        <SubtitleItem
                           showTitle={showSubtitleLabel}
                           value={
                              (subtitle !== "-" || subtitle === null) && fixedHTML(rows[subtitle])
                           }
                           title={subtitle}
                        />
                     </span>
                     <UserItem
                        showTitle={showUserLabel}
                        value={(user !== "-" || user === null) && fixedHTML(rows[user])}
                        title={user}
                     />
                     <span>
                        <CalendarItem
                           showTitle={showCalendarLabel}
                           value={
                              (calendar !== "-" || calendar === null) && fixedHTML(rows[calendar])
                           }
                           title={calendar}
                           format={calendarFormat}
                        />
                     </span>
                     <span>
                        <SubKeyInfoItem
                           showTitle={showSubKeyInfoLabel}
                           value={
                              (subKeyInfo !== "-" || subKeyInfo === null) &&
                              fixedHTML(rows[subKeyInfo])
                           }
                           title={subKeyInfo}
                        />
                     </span>
                  </div>
                  <div className="columns2">
                     <KeyInfoItem
                        showTitle={showKeyInfoLabel}
                        value={(keyInfo !== "-" || keyInfo === null) && fixedHTML(rows[keyInfo])}
                        title={keyInfo}
                     />
                     <ColumnsItem
                        rows={rows}
                        columns={columns}
                        restOfColumns={restOfColumns}
                        showTitle={showRestOfColumnsLabel}
                     />
                  </div>
               </div>
            ) : (
               <div
                  className="avdertisement-item-body"
                  onClick={handleModalOpen}
                  style={{ cursor: previewOnClick && !!displayFormChildId && "pointer" }}
               >
                  <LabelItem
                     showTitle={showLabelLabel}
                     value={(label !== "-" || label === null) && fixedHTML(rows[label])}
                     title={label}
                  />
                  <MainTitleItem
                     showTitle={showMainTitleLabel}
                     value={(mainTitle !== "-" || mainTitle === null) && fixedHTML(rows[mainTitle])}
                     title={mainTitle}
                  />
                  <SubtitleItem
                     showTitle={showSubtitleLabel}
                     value={(subtitle !== "-" || subtitle === null) && fixedHTML(rows[subtitle])}
                     title={subtitle}
                  />
                  <div className="avdertisement-item__key-info-container">
                     <KeyInfoItem
                        showTitle={showKeyInfoLabel}
                        value={(keyInfo !== "-" || keyInfo === null) && fixedHTML(rows[keyInfo])}
                        title={keyInfo}
                     />
                     <KeyInfoItem
                        showTitle={showSubKeyInfoLabel}
                        value={
                           (subKeyInfo !== "-" || subKeyInfo === null) &&
                           fixedHTML(rows[subKeyInfo])
                        }
                        title={subKeyInfo}
                     />
                  </div>
                  <UserItem
                     showTitle={showUserLabel}
                     value={(user !== "-" || user === null) && fixedHTML(rows[user])}
                     title={user}
                  />
                  <CalendarItem
                     showTitle={showCalendarLabel}
                     value={(calendar !== "-" || calendar === null) && fixedHTML(rows[calendar])}
                     title={calendar}
                     format={calendarFormat}
                  />

                  <ColumnsItem
                     rows={rows}
                     columns={columns}
                     restOfColumns={restOfColumns}
                     showTitle={showRestOfColumnsLabel}
                  />
               </div>
            )}
            {buttons ? <div className="avdertisement-item-buttons">{buttons}</div> : ""}
            {previewOnClick && !!displayFormChildId && (
               <Modal
                  isOpen={isPreviewOpen}
                  onCancel={() => setIsPreviewOpen(false)}
                  bodyStyles={{
                     display: "grid",
                     placeItems: "center",
                     minHeight: 200,
                     overflow: "scroll",
                  }}
                  width={800}
                  style={{ maxWidth: 800 }}
               >
                  <FormComplete
                     formId={displayFormChildId}
                     dataId={rows.api_rowMetaData?.recordId}
                     isReadOnly={true}
                     saveCallback={() => setIsPreviewOpen(false)}
                  />
               </Modal>
            )}
         </div>
      </div>
   );
};

export default AdvertisementItem;
